module.exports = __webpack_public_path__ + "img/2.9268586d.png";